/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Phrase_New_RoleInputs */



/**
* | output |
* | --- |
* | "a new role" |
*
* @param {Leveling_Phrase_New_RoleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_phrase_new_role = /** @type {((inputs?: Leveling_Phrase_New_RoleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Phrase_New_RoleInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("новая роль")
	return /** @type {LocalizedString} */ ("a new role")
});